import AdminApp from '@/admin/App'

import AdminSession from '@/admin/pages/sessions/Index'

import AdminContractors from '@/admin/pages/contractors/Index'
import AdminContractor from '@/admin/pages/contractors/Show'
import AdminContractorNew from '@/admin/pages/contractors/New'
import AdminContractorEdit from '@/admin/pages/contractors/Edit'

import AdminEdiRequests from '@/admin/pages/edi_requests/Index'
import AdminEdiRequestCsvImport from '@/admin/pages/edi_requests/Import'

import AdminNotifications from '@/admin/pages/notifications/Index'
import AdminNotificationNew from '@/admin/pages/notifications/New'
import AdminNotificationEdit from '@/admin/pages/notifications/Edit'

import AdminTopics from '@/admin/pages/topics/Index'
import AdminTopicNew from '@/admin/pages/topics/New'
import AdminTopicEdit from '@/admin/pages/topics/Edit'

import AdminDxeNotifications from '@/admin/pages/dxe_notifications/Index'

import AdminUsers from '@/admin/pages/users/Index'
import AdminUser from '@/admin/pages/users/Show'
import AdminUserNew from '@/admin/pages/users/New'
import AdminUserEdit from '@/admin/pages/users/Edit'

import AdminTenantUsers from '@/admin/pages/tenant_users/Index'

import AdminMasterEmissions from '@/admin/pages/masters/emissions/Index'
import AdminMasterEmission from '@/admin/pages/masters/emissions/Show'
import AdminMasterEmissionNew from '@/admin/pages/masters/emissions/New'
import AdminMasterEmissionEdit from '@/admin/pages/masters/emissions/Edit'
import AdminMasterEmissionCsvImport from '@/admin/pages/masters/emissions/EmissionImport'

import AdminMasterTransports from '@/admin/pages/masters/transports/Index'

import AdminMasterTransport  from '@/admin/pages/masters/transports/Show'
import AdminMasterTransportCsvImport from '@/admin/pages/masters/transports/TransportImport'

import AdminMasterDisposers from '@/admin/pages/masters/disposers/Index'
import AdminMasterDisposer  from '@/admin/pages/masters/disposers/Show'
import AdminMasterDisposerCsvImport from '@/admin/pages/masters/disposers/DisposerImport'

import AdminMasterOrdinanceCities from '@/admin/pages/masters/ordinance_cities/Index'

import AdminSystemShow from '@/admin/pages/systems/Show'
import AdminSystemEdit from '@/admin/pages/systems/Edit'

import AdminInvoices    from '@/admin/pages/invoices/Index'
import AdminManifestReports    from '@/admin/pages/manifest_reports/Index'

import AdminApps from '@/admin/pages/apps/Index'

import AdminMasterQuantityUnits from '@/admin/pages/masters/quantity_units/Index'
import AdminMasterQuantityUnit from '@/admin/pages/masters/quantity_units/Show'
import AdminMasterQuantityUnitNew from '@/admin/pages/masters/quantity_units/New'
import AdminMasterQuantityUnitEdit from '@/admin/pages/masters/quantity_units/Edit'

import AdminMasterPackings from '@/admin/pages/masters/packings/Index'
import AdminMasterPacking from '@/admin/pages/masters/packings/Show'
import AdminMasterPackingNew from '@/admin/pages/masters/packings/New'
import AdminMasterPackingEdit from '@/admin/pages/masters/packings/Edit'

import AdminMasterTransportations from '@/admin/pages/masters/transportations/Index'
import AdminMasterTransportation from '@/admin/pages/masters/transportations/Show'
import AdminMasterTransportationNew from '@/admin/pages/masters/transportations/New'
import AdminMasterTransportationEdit from '@/admin/pages/masters/transportations/Edit'

import AdminMasterQuantityConfirms from '@/admin/pages/masters/quantity_confirms/Index'
import AdminMasterQuantityConfirm from '@/admin/pages/masters/quantity_confirms/Show'
import AdminMasterQuantityConfirmNew from '@/admin/pages/masters/quantity_confirms/New'
import AdminMasterQuantityConfirmEdit from '@/admin/pages/masters/quantity_confirms/Edit'

import AdminMasterHazardousSubStances from '@/admin/pages/masters/hazardous_substances/Index'
import AdminMasterHazardousSubStance from '@/admin/pages/masters/hazardous_substances/Show'
import AdminMasterHazardousSubStanceNew from '@/admin/pages/masters/hazardous_substances/New'
import AdminMasterHazardousSubStanceEdit from '@/admin/pages/masters/hazardous_substances/Edit'

import AdminMasterItems from '@/admin/pages/masters/items/Index'
import AdminMasterItemNew from '@/admin/pages/masters/items/New'
import AdminMasterItemEdit from '@/admin/pages/masters/items/Edit'

import AdminMasterDisposalMethods from '@/admin/pages/masters/disposal_methods/Index'
import AdminMasterDisposalMethod from '@/admin/pages/masters/disposal_methods/Show'
import AdminMasterDisposalMethodNew from '@/admin/pages/masters/disposal_methods/New'
import AdminMasterDisposalMethodEdit from '@/admin/pages/masters/disposal_methods/Edit'

import AdminEdiSettingsManagements from '@/admin/pages/edi_settings/managements/Index'

import AdminContractsSummaries from '@/admin/pages/contracts/summaries/Index'

import AdminSchedulesJwnetMaintenances from '@/admin/pages/schedules/jwnet_maintenances/Index'
import AdminSchedulesWansignMaintenances from '@/admin/pages/schedules/wansign_maintenances/Index'
import AdminSchedulesDbMaintenances from '@/admin/pages/schedules/db_maintenances/Index'



export default {
  path: '/admin',
  component: AdminApp,
  children: [
    { path: '/admin/', name: 'AdminSession', component: AdminSession, meta: { isPublic: true } },

    { path: '/admin/contractors', name: 'AdminContractors', component: AdminContractors },
    { path: '/admin/contractors/new', name: 'AdminContractorNew', component: AdminContractorNew },
    { path: '/admin/contractors/:id', name: 'AdminContractor', component: AdminContractor, meta: { description: '契約者参照' } },
    { path: '/admin/contractors/:id/edit', name: 'AdminContractorEdit', component: AdminContractorEdit },

    { path: '/admin/edi_requests', name: 'AdminEdiRequests', component: AdminEdiRequests },
    { path: '/admin/edi_requests/import', name: 'AdminEdiRequestCsvImport', component: AdminEdiRequestCsvImport, meta: {} },
    
    { path: '/admin/notifications', name: 'AdminNotifications', component: AdminNotifications },
    { path: '/admin/notifications/new', name: 'AdminNotificationNew', component: AdminNotificationNew },
    { path: '/admin/notifications/:id/edit', name: 'AdminNotificationEdit', component: AdminNotificationEdit },

    { path: '/admin/topics', name: 'AdminTopics', component: AdminTopics },
    { path: 'admin/topics/new', name: 'AdminTopicNew', component: AdminTopicNew },
    { path: '/admin/topics/:id/edit', name: 'AdminTopicEdit', component: AdminTopicEdit },

    { path: '/admin/dxe_notifications', name: 'AdminDxeNotifications', component: AdminDxeNotifications },

    { path: '/admin/users', name: 'AdminUsers', component: AdminUsers },
    { path: '/admin/users/new', name: 'AdminUserNew', component: AdminUserNew },
    { path: '/admin/users/:id', name: 'AdminUser', component: AdminUser },
    { path: '/admin/users/:id/edit', name: 'AdminUserEdit', component: AdminUserEdit },

    { path: '/admin/tenant_users', name: 'AdminTenantUsers', component: AdminTenantUsers },

    { path: '/admin/masters/emissions', name: 'AdminMasterEmissions', component: AdminMasterEmissions },
    { path: '/admin/masters/emissions/new', name: 'AdminMasterEmissionNew', component: AdminMasterEmissionNew },
    { path: '/admin/masters/emissions/import', name: 'AdminMasterEmissionCsvImport', component: AdminMasterEmissionCsvImport },
    { path: '/admin/masters/emissions/:id', name: 'AdminMasterEmission', component: AdminMasterEmission },
    { path: '/admin/masters/emissions/:id/edit', name: 'AdminMasterEmissionEdit', component: AdminMasterEmissionEdit },

    { path: '/admin/masters/transports', name: 'AdminMasterTransports', component: AdminMasterTransports },
    { path: '/admin/masters/transports/import',  name: 'AdminMasterTransportCsvImport', component: AdminMasterTransportCsvImport },
    { path: '/admin/masters/transports/:id', name: 'AdminMasterTransport', component: AdminMasterTransport },

    { path: '/admin/masters/disposers', name: 'AdminMasterDisposers', component: AdminMasterDisposers },
    { path: '/admin/masters/disposers/import',  name: 'AdminMasterDisposerCsvImport', component: AdminMasterDisposerCsvImport },
    { path: '/admin/masters/disposers/:id', name: 'AdminMasterDisposer', component: AdminMasterDisposer },
    { path: '/admin/masters/ordinance_cities', name: 'AdminMasterOrdinanceCities', component: AdminMasterOrdinanceCities },

    { path: '/admin/systems/:type(emission|edi_request)',      name: 'AdminSystemShow', component: AdminSystemShow },
    { path: '/admin/systems/:type(emission|edi_request)/edit', name: 'AdminSystemEdit', component: AdminSystemEdit },

    { path: '/admin/invoices',   name: 'AdminInvoices', component: AdminInvoices },
    { path: '/admin/manifest_reports',   name: 'AdminManifestReports', component: AdminManifestReports },

    { path: '/admin/apps', name: 'AdminApps', component: AdminApps },

    { path: '/admin/masters/quantity_units', name: 'AdminMasterQuantityUnits', component: AdminMasterQuantityUnits },
    { path: '/admin/masters/quantity_units/new', name: 'AdminMasterQuantityUnitNew', component: AdminMasterQuantityUnitNew },
    { path: '/admin/masters/quantity_units/:id', name: 'AdminMasterQuantityUnit', component: AdminMasterQuantityUnit },
    { path: '/admin/masters/quantity_units/:id/edit', name: 'AdminMasterQuantityUnitEdit', component: AdminMasterQuantityUnitEdit },

    { path: '/admin/masters/packings', name: 'AdminMasterPackings', component: AdminMasterPackings },
    { path: '/admin/masters/packings/new', name: 'AdminMasterPackingNew', component: AdminMasterPackingNew },
    { path: '/admin/masters/packings/:id', name: 'AdminMasterPacking', component: AdminMasterPacking },
    { path: '/admin/masters/packings/:id/edit', name: 'AdminMasterPackingEdit', component: AdminMasterPackingEdit },

    { path: '/admin/masters/transportations', name: 'AdminMasterTransportations', component: AdminMasterTransportations },
    { path: '/admin/masters/transportations/new', name: 'AdminMasterTransportationNew', component: AdminMasterTransportationNew },
    { path: '/admin/masters/transportations/:id', name: 'AdminMasterTransportation', component: AdminMasterTransportation },
    { path: '/admin/masters/transportations/:id/edit', name: 'AdminMasterTransportationEdit', component: AdminMasterTransportationEdit },

    { path: '/admin/masters/quantity_confirms', name: 'AdminMasterQuantityConfirms', component: AdminMasterQuantityConfirms },
    { path: '/admin/masters/quantity_confirms/new', name: 'AdminMasterQuantityConfirmNew', component: AdminMasterQuantityConfirmNew },
    { path: '/admin/masters/quantity_confirms/:id', name: 'AdminMasterQuantityConfirm', component: AdminMasterQuantityConfirm },
    { path: '/admin/masters/quantity_confirms/:id/edit', name: 'AdminMasterQuantityConfirmEdit', component: AdminMasterQuantityConfirmEdit },

    { path: '/admin/masters/hazardous_substances', name: 'AdminMasterHazardousSubStances', component: AdminMasterHazardousSubStances },
    { path: '/admin/masters/hazardous_substances/new', name: 'AdminMasterHazardousSubStanceNew', component: AdminMasterHazardousSubStanceNew },
    { path: '/admin/masters/hazardous_substances/:id', name: 'AdminMasterHazardousSubStance', component: AdminMasterHazardousSubStance },
    { path: '/admin/masters/hazardous_substances/:id/edit', name: 'AdminMasterHazardousSubStanceEdit', component: AdminMasterHazardousSubStanceEdit },

    { path: '/admin/masters/items', name: 'AdminMasterItems', component: AdminMasterItems },
    { path: '/admin/masters/items/new', name: 'AdminMasterItemNew', component: AdminMasterItemNew },
    { path: '/admin/masters/items/:id/edit', name: 'AdminMasterItemEdit', component: AdminMasterItemEdit },

    { path: '/admin/masters/disposal_methods', name: 'AdminMasterDisposalMethods', component: AdminMasterDisposalMethods },
    { path: '/admin/masters/disposal_methods/new', name: 'AdminMasterDisposalMethodNew', component: AdminMasterDisposalMethodNew },
    { path: '/admin/masters/disposal_methods/:id', name: 'AdminMasterDisposalMethod', component: AdminMasterDisposalMethod },
    { path: '/admin/masters/disposal_methods/:id/edit', name: 'AdminMasterDisposalMethodEdit', component: AdminMasterDisposalMethodEdit },

    { path: '/admin/edi_sessings/managements', name: 'AdminEdiSettingsManagements', component: AdminEdiSettingsManagements },
  
    { path: '/admin/contract/total_signatures', name: 'AdminContractsSummaries', component: AdminContractsSummaries },

    { path: '/admin/schedules/jwnet_maintenances', name: 'AdminSchedulesJwnetMaintenances', component: AdminSchedulesJwnetMaintenances },
    { path: '/admin/schedules/wansign_maintenances', name: 'AdminSchedulesWansignMaintenances', component: AdminSchedulesWansignMaintenances },
    { path: '/admin/schedules/db_maintenances', name: 'AdminSchedulesDbMaintenances', component: AdminSchedulesDbMaintenances },

  ]

}
